import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, inputTextColumn, inputNumberColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P105List_1({ dataTable, inpusText }) {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    const disableField = () => {
        if (dataTable !== undefined) {
            if (dataTable.length) {
                return dataTable[0].displayMode === "N" ? false : true;
            }
        }
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows}
                    onPage={(e) => onPageChange(e, setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    globalFilter={globalFilter}
                    emptyMessage="ยังไม่ได้เพิ่มรายการ"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="caseType" header="ลักษณะงาน" body={(e) => normalColumn(e, "caseType", "ลักษณะงาน")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="casePipeSize" header="ขนาด" body={(e) => normalColumn(e, "casePipeSize", "ขนาด")} style={{ textAlign: "center", width: "6%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="caseQuantityRequest" header="ปริมาณที่ขอ" body={(e) => normalColumn(e, "caseQuantityRequest", "ปริมาณที่ขอ")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    {/* <Column  field="caseUnit" header="หน่วย" body={(e) => normalColumn(e, "caseUnit", "หน่วย")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} /> */}

                    <Column field="caseUnit" header="หน่วย" body={(e) => inputTextColumn(e, "caseUnit", dataTable, inpusText, "หน่วย", "หน่วย", "caseUnit", true, "200")} style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column sortable field="caseQuantityReport" header="ปริมาณที่ทำ" body={(e) => inputNumberColumn(e, "caseQuantityReport", dataTable, inpusText, "ปริมาณที่ทำ", "ปริมาณที่ทำ", "caseQuantityReport", disableField(), 9999999999, 2)} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column sortable field="remark" header="หมายเหตุ" body={(e) => inputTextColumn(e, "remark", dataTable, inpusText, "หมายเหตุ", "หมายเหตุ", "remark", disableField(), "200")} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                </DataTable>
            </div>
        </div>
    );
}
